const DEFAULT_API_BASE_URL = "/api-rewards";
const USE_HARDCODED_CONVERSATION = false;
const loadConversation = async ({
  conversationId,
  sharedConversationId,
  headersToInject,
  apiBaseUrl = DEFAULT_API_BASE_URL
}) => {
  if (!conversationId && !sharedConversationId) {
    return null;
  }
  try {
    const headers = {
      ...headersToInject,
      "Content-Type": "application/json"
    };
    const url = sharedConversationId ? `${apiBaseUrl}/concierge/conversation/shared/${sharedConversationId}/ui-messages` : `${apiBaseUrl}/concierge/conversation/${conversationId}/ui-messages`;
    const response = await fetch(url, { method: "GET", headers });
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      if (response.status === 403) {
        const data = await response.json();
        return { messages: [], error: "unauthorized", redirect: data.redirect };
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const messagesData = await response.json();
    if (messagesData.error) {
      console.error("Error loading conversation:", messagesData.error);
      return null;
    }
    const messages = (messagesData.messages || []).map((message) => {
      var _a;
      const id = message.id || `msg-${message.messageIndex ?? Date.now()}`;
      const role = message.role === "user" ? "user" : "assistant";
      const parts = ((_a = message.parts) == null ? void 0 : _a.length) ? message.parts : [{ type: "text", text: "" }];
      return {
        id,
        role,
        parts,
        ...message.createdAt ? { createdAt: message.createdAt } : {},
        ...message.messageIndex != null ? { messageIndex: message.messageIndex } : {},
        ...message.feedback ? { feedback: message.feedback } : {}
      };
    });
    return {
      conversationId: messagesData.conversationId || conversationId || void 0,
      status: messagesData.status,
      messages,
      followUpQuestions: messagesData.followUpQuestions || [],
      isSharedView: messagesData.isSharedView,
      sharedConversationId: messagesData.sharedConversationId || sharedConversationId || void 0,
      sharedAtMessageIndex: messagesData.sharedAtMessageIndex,
      sharedByUserName: messagesData.sharedByUserName,
      sourceConversationId: messagesData.sourceConversationId,
      sourceCheckpointIndex: messagesData.sourceCheckpointIndex
    };
  } catch (error) {
    console.error("Failed to load conversation:", error);
    return null;
  }
};
const sendMessageFeedback = async ({
  conversationId,
  messageIndex,
  feedbackType,
  headersToInject,
  apiBaseUrl = DEFAULT_API_BASE_URL
}) => {
  const headers = {
    ...headersToInject,
    "Content-Type": "application/json"
  };
  const response = await fetch(`${apiBaseUrl}/concierge/message/feedback`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      conversationId,
      messageIndex,
      feedbackType
    })
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};
const setConversationSharing = async ({
  conversationId,
  enabled,
  messageIndex,
  headersToInject,
  apiBaseUrl = DEFAULT_API_BASE_URL
}) => {
  const headers = {
    ...headersToInject,
    "Content-Type": "application/json"
  };
  const response = await fetch(`${apiBaseUrl}/concierge/conversation/${conversationId}/share`, {
    method: "POST",
    headers,
    body: JSON.stringify({ enabled, messageIndex })
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};
const retryConversation = async ({
  conversationId,
  headersToInject,
  apiBaseUrl = DEFAULT_API_BASE_URL
}) => {
  const headers = {
    ...headersToInject,
    "Content-Type": "application/json"
  };
  const response = await fetch(`${apiBaseUrl}/concierge/conversation/${conversationId}/retry`, {
    method: "POST",
    headers
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `HTTP ${response.status}`);
  }
  return response.json();
};
const stopConversation = async ({
  conversationId,
  headersToInject,
  apiBaseUrl = DEFAULT_API_BASE_URL
}) => {
  const headers = {
    ...headersToInject,
    "Content-Type": "application/json"
  };
  const response = await fetch(`${apiBaseUrl}/concierge/conversation/${conversationId}/stop`, {
    method: "POST",
    headers
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `HTTP ${response.status}`);
  }
  return response.json();
};
const fetchDevOptions = async ({
  headersToInject,
  apiBaseUrl = DEFAULT_API_BASE_URL
} = {}) => {
  try {
    const headers = {
      ...headersToInject,
      "Content-Type": "application/json"
    };
    const response = await fetch(`${apiBaseUrl}/concierge/devOptions`, {
      method: "GET",
      headers
    });
    if (!response.ok) {
      console.warn("Failed to fetch dev options from server, using local defaults");
      return null;
    }
    return await response.json();
  } catch (error) {
    console.warn("Error fetching dev options:", error);
    return null;
  }
};
const fetchProductByStacklineSku = async ({
  stacklineSku,
  headersToInject,
  apiBaseUrl = DEFAULT_API_BASE_URL
}) => {
  try {
    const headers = {
      ...headersToInject,
      "Content-Type": "application/json"
    };
    const response = await fetch(`${apiBaseUrl}/product/${stacklineSku}`, {
      method: "GET",
      headers
    });
    if (!response.ok) {
      if (response.status === 404) {
        return null;
      }
      throw new Error(`Failed to fetch product: ${response.status}`);
    }
    const data = await response.json();
    return data.product || data;
  } catch (error) {
    console.error("Error fetching product by stacklineSku:", error);
    return null;
  }
};
export {
  USE_HARDCODED_CONVERSATION,
  fetchDevOptions,
  fetchProductByStacklineSku,
  loadConversation,
  retryConversation,
  sendMessageFeedback,
  setConversationSharing,
  stopConversation
};
//# sourceMappingURL=api.js.map
